
























import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';
import EmailFieldValidator from './validation/EmailFieldValidator.vue';

@Component({
  inheritAttrs: false,
  components: {
    RequiredFieldValidator,
    EmailFieldValidator
  }
})
export default class FormInput extends Mixins(FormFieldMixin) {
  @Prop() readonly type!: string;
  @Prop() readonly value!: string;

  $refs!: {
    inputElement: HTMLFormElement;
  };

  public focusInput (): void {
    this.$refs.inputElement.focus();
  }

  public hasValue (): boolean {
    return this.value !== undefined && this.value !== null && this.value !== '';
  }
}
